import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'ContentEndLevelPopupLayout',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '05010f98-1625-496a-859f-8d4933433706',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '7e821abc-d372-445a-97b7-718c735ea6f1',
      type: 'Container',
      name: 'sideContainer',
      nameSpace: '',
      className: '',
      x: 300,
      y: -248,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '5cc0e50b-3468-459b-9786-5a36aeecfa5f',
      type: 'Sprite',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 0.942006
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_background_2',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'f3747082-1b45-46bb-9c81-ceb9f994569d',
      type: 'NineSlicePlane',
      name: '',
      nameSpace: '',
      className: '',
      x: -355,
      y: -119,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 710,
      height: 356,
      leftWidth: 64,
      topHeight: 64,
      rightWidth: 64,
      bottomHeight: 64,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'replay_text_area',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '0d02c613-ef36-4e94-86a4-e7245b6090dc',
      type: 'Sprite',
      name: 'headerBg',
      nameSpace: '',
      className: '',
      x: -4,
      y: -266,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'header_blank',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6b8770b9-2782-4329-8551-7b5c5ee148f9',
      type: 'Text',
      name: 'headerText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Congratulations',
      localize: true,
      maxWidth: 524,
      maxHeight: 121,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 29,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#933019',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '3b9dbbb0-b7f5-4938-89c7-e9582233102a',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 361,
      y: -273,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      type: 'Sprite',
      name: 'buttonContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blank',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '280699fb-d598-46e8-9ddd-c56b604573e7',
      type: 'Container',
      name: 'mainContent',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: '15be72c1-a4a7-421a-94d4-3e4c908b941a',
      type: 'Sprite',
      name: 'character',
      nameSpace: '',
      className: '',
      x: -458,
      y: 380,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'character_idle_1',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'dee777d5-06d5-41ab-a79c-d4f1a8fae8a9',
      type: 'Sprite',
      name: 'grass',
      nameSpace: '',
      className: '',
      x: 665,
      y: 380,
      anchor: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'charly_grass',
      parent: '05010f98-1625-496a-859f-8d4933433706',
      data: ''
    },
    {
      id: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      type: 'Sprite',
      name: 'playButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '6635b2ef-0304-4c20-bb80-a1e9f6eea59f',
      data: ''
    },
    {
      id: '013a20b6-2e6b-49b0-9c24-1a3582e68c3e',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -146,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EndOfContentDesc1',
      localize: true,
      maxWidth: 539,
      maxHeight: 43,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#982513',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      type: 'Container',
      name: 'imageContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '7021b05d-9b1c-4ff4-bd48-6e4ede2844a9',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 126,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'EndOfContentDesc2',
      localize: true,
      maxWidth: 598,
      maxHeight: 133,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 23,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#982513',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '280699fb-d598-46e8-9ddd-c56b604573e7',
      data: ''
    },
    {
      id: '0c86af15-f2f5-4427-97e7-5ee8e8130084',
      type: 'Sprite',
      name: 'charly',
      nameSpace: '',
      className: '',
      x: 15,
      y: 0,
      anchor: {
        x: 0,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'charly_base',
      parent: 'dee777d5-06d5-41ab-a79c-d4f1a8fae8a9',
      data: ''
    },
    {
      id: '48169862-db2a-4458-8134-5c976489402b',
      type: 'Text',
      name: 'playText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'LetsGo',
      localize: true,
      maxWidth: 226,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#074829',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f4c22154-70cc-4c5a-b9b2-a75459e6c891',
      data: ''
    },
    {
      id: '741f48ac-5920-4759-afba-3596f0e3010d',
      type: 'Sprite',
      name: 'check',
      nameSpace: '',
      className: '',
      x: 250,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'replay_check_icon',
      parent: '013a20b6-2e6b-49b0-9c24-1a3582e68c3e',
      data: ''
    },
    {
      id: 'a25953ea-0ce1-473e-90f6-1776337e9b55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: 'stars',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.88,
        y: 0.88
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'replay_banner',
      parent: '1a1bb1f4-42aa-43dc-8aa6-1b0fce8e8cd2',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class ContentEndLevelPopupLayout {
  static raw = raw;
  root: PIXI.Container
  sideContainer: PIXI.Container
  bg: PIXI.Sprite
  headerBg: PIXI.Sprite
  headerText: PIXI.Text
  closeButton: PIXI.Sprite
  buttonContainer: PIXI.Sprite
  playButton: PIXI.Sprite
  playText: PIXI.Text
  mainContent: PIXI.Container
  check: PIXI.Sprite
  imageContainer: PIXI.Container
  character: PIXI.Sprite
  grass: PIXI.Sprite
  charly: PIXI.Sprite
  stars: (PIXI.Sprite)[]

  constructor() {
    populate(this, raw);
  }
}
